import React from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const PaymentOptions = () => {
    return (
        strings.payments.map((payment, i) => <option key={i} value={payment.value}>{payment.name}</option>)
    )
}

export default PaymentOptions;


// WEBPACK FOOTER //
// ./src/components/Common/PaymentOptions/PaymentOptions.js